import React from 'react'
import CustomerSharingFeatureBox1 from './customersharing-feature-box1'
function Customerfeature() {
    return (
        <>
            <CustomerSharingFeatureBox1 />
        </>
    )
}

export default Customerfeature